import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import App from './App'
import FacilityUseForm from './pages/FacilityUseForm'
import GlobalStyles from './styles/GlobalStyles'
import AuthGate from './auth/AuthGate'
import AuthCallbackPage from './auth/AuthCallbackPage'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GlobalStyles />
    <BrowserRouter>
      <Routes>
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route
          path="/"
          element={
            <AuthGate>
              <Navigate to="/app" replace />
            </AuthGate>
          }
        />
        <Route
          path="/app"
          element={
            <AuthGate>
              <App />
            </AuthGate>
          }
        />
        <Route
          path="/facility_use"
          element={<FacilityUseForm />}
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
) 